"use strict";

/* FNC: preusmjeravanje pozadinskih slika launch stranice na Shopify CDN (ociscen tekst na vrecici) */
(function () {
  var BASE = "https://cdn.shopify.com/s/files/1/1076/2931/4387/files/";
  var MAP = {
    "7d216ec0-96c6-47c9-8468-f7c3c14dcf22": "fnc-launch-lg-0.jpg",
    "c2d432a7-4476-4bc1-a611-fa648a315971": "fnc-launch-lg-1.jpg",
    "a136e198-2691-4f7e-b695-8a43584ae6ff": "fnc-launch-lg-2.jpg",
    "7587d271-623a-4879-98cf-102a90757107": "fnc-launch-lg-3.jpg",
    "4a49feae-530b-4906-84f2-c25d86717c6f": "fnc-launch-lg-4.jpg",
    "755cfc73-67f3-4845-b771-9e910242a4f1": "fnc-launch-lg-5.jpg",
    "32f74ba6-6184-40e5-b69d-3fd04e7d1ff3": "fnc-launch-lgx-0.jpg",
    "1f5ec08a-f802-44b7-8fde-0eaf334f471a": "fnc-launch-lgx-1.jpg",
    "56f1098b-f02a-44a8-8a83-5d18432d0a9c": "fnc-launch-lgx-2.jpg",
    "f2b38240-0081-4f78-a233-4766b7b3bb76": "fnc-launch-lgx-3.jpg",
    "40ad4a97-3431-4294-9730-a637c8b94e88": "fnc-launch-lgx-4.jpg",
    "9e0f672e-f934-4a89-ad0f-98858404d72b": "fnc-launch-lgx-5.jpg",
    "709efdd5-3cb2-429b-b2b5-7af46fc51161": "fnc-launch-vt-0.jpg",
    "04b89d03-3927-44ac-941c-b9b419f2794d": "fnc-launch-vt-1.jpg",
    "3fa0eeeb-bb8f-4b3a-9470-04df449422a6": "fnc-launch-vt-2.jpg",
    "edf009c2-2230-406f-bff3-5d3912199fef": "fnc-launch-vt-3.jpg",
    "e51e9cd0-8b40-4582-9f69-bf235fd411ec": "fnc-launch-vt-4.jpg",
    "d16936f7-1ed5-439c-b2df-9e63af64e859": "fnc-launch-vt-5.jpg"
  };
  function fncmap(u) {
    if (!u || u.indexOf("d2ol7oe51mr4n9.cloudfront.net") < 0) return null;
    var m = u.match(/([0-9a-fA-F-]{36})\.jpg/);
    if (!m || !MAP[m[1]]) return null;
    return BASE + MAP[m[1]];
  }
  try {
    var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
    if (d && d.set && d.get) {
      Object.defineProperty(HTMLImageElement.prototype, "src", {
        configurable: true,
        enumerable: d.enumerable,
        get: function () { return d.get.call(this); },
        set: function (v) { var n = fncmap(String(v)); d.set.call(this, n || v); }
      });
    }
  } catch (e) {}
  function fncsweep() {
    var im = document.getElementsByTagName("img");
    for (var i = 0; i < im.length; i++) {
      var n = fncmap(im[i].getAttribute("src"));
      if (n) im[i].setAttribute("src", n);
    }
  }
  fncsweep();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fncsweep);
  try {
    new MutationObserver(fncsweep).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["src"]
    });
  } catch (e) {}
  setTimeout(fncsweep, 800);
  setTimeout(fncsweep, 3000);
})();


var BlsPasswordPopup = (function () {
    return {
      init: function () {
        this.handleCountdown()
        this.showPassword();
      },
      showPassword: function () {
        const action = document.querySelector("#DialogHeading");
        const _this = this;
        if (action !== null) {
          action.addEventListener("click", (e) => {
            e.preventDefault();
            _this.getContentPassword();
          });
        }
      },
      getContentPassword: function(){
        const content = document.querySelector('.password-modal__content').innerHTML;
        let modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ["overlay", "button", "escape"],
          cssClass: ['password-modal'],
          onOpen: function () {},
          onClose: function () {},
          beforeClose: function () {
            return true;
          },
        }); 
        modal.setContent(content);
        modal.open();
      },
      handleCountdown: function () {
        var second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;
        const timer = document.querySelectorAll(".bls__timer");
        if(timer){
          timer.forEach((e) => {
            const { timer } = e?.dataset;
            const dateParts = timer.split("-");
            const isoDate =
              dateParts[2] +
              "-" +
              dateParts[0].padStart(2, "0") +
              "-" +
              dateParts[1].padStart(2, "0") +
              "T00:00:00Z";
            if (Date.parse(isoDate)) {
              var countDown = new Date(isoDate).getTime();
              if (countDown) {
                setInterval(function () {
                  var now = new Date().getTime(),
                    distance = countDown - now;
                  if (countDown >= now) {
                    (e.querySelector(".js-timer-days").innerText =
                      Math.floor(distance / day) < 10
                        ? ("0" + Math.floor(distance / day)).slice(-2)
                        : Math.floor(distance / day)),
                      (e.querySelector(".js-timer-hours").innerText = (
                        "0" + Math.floor((distance % day) / hour)
                      ).slice(-2)),
                      (e.querySelector(".js-timer-minutes").innerText = (
                        "0" + Math.floor((distance % hour) / minute)
                      ).slice(-2)),
                      (e.querySelector(".js-timer-seconds").innerText = (
                        "0" + Math.floor((distance % minute) / second)
                      ).slice(-2));
                  }
                }, second);
              }
            }
          });
        }
      
      },
       
    };
  })();
  BlsPasswordPopup.init();


  
/* FNC: tvrdi prijelaz izmedu frameova - uvijek je vidljiva samo jedna vrecica (bez duplog obrisa) */
(function () {
  var CSS = ".fnq__stage img.fnc-on{opacity:1!important;transition:none!important}" +
            ".fnq__stage img.fnc-off{opacity:0!important;transition:none!important}";
  function fncAddCss() {
    if (!document.head || document.getElementById("fnc-snap-css")) return;
    var s = document.createElement("style");
    s.id = "fnc-snap-css";
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function fncSnap() {
    fncAddCss();
    var a = document.querySelectorAll(".fnq__stage img");
    for (var i = 0; i < a.length; i++) {
      var raw = a[i].style.opacity;
      if (raw === "" || raw === null || raw === undefined) {
        a[i].classList.remove("fnc-on");
        a[i].classList.remove("fnc-off");
        continue;
      }
      var v = parseFloat(raw);
      if (isNaN(v)) continue;
      a[i].classList.toggle("fnc-on", v >= 0.5);
      a[i].classList.toggle("fnc-off", v < 0.5);
    }
  }
  fncSnap();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fncSnap);
  setTimeout(fncSnap, 400);
  setTimeout(fncSnap, 1200);
  setTimeout(fncSnap, 3000);
  setInterval(fncSnap, 1000);
})();
